
import { Component, Vue, Prop } from 'vue-property-decorator';
import { store, action } from '@/common/store';
import { getTabsData, getVoteData, VoteDo, isDebug } from '@/common/api';
import { getScoreProcessWidth } from '@/common/utils';
import PosterDialog from './PosterDialog.vue';
import VotePk from './VotePk.vue';
import login from '@common/login';

@Component({
  name: 'VoteModule',
  components: {
    PosterDialog,
    VotePk,
  },
})
export default class VoteModule extends Vue {
  tabsDataList = [] as any;
  videoUrl = 'https://www.bilibili.com/blackboard/newplayer.html?arp=1';
  imgUrl = '';
  isVote = false; // 是否投票
  actId = null as any;
  groupId = null as any;
  chooseIdx = 0;
  userCanVoteCount1 = 1
  userCanVoteCount2 = 1
  leftRatio = 50;
  rightRatio = 50;
  sonQuery = {
    leftLongWidth: null,
    rightLongWidth: null,
    len: null,
  } as any;
  player = null as any;
  bvid = '';
  isMask = true;
  voteList = [];
  datasourceIitemObject = {
    left: null,
    right: null,
  } as any;

  get getUserInfo() {
    return store.userInfo || false;
  }

  async mounted() {
    const script = document.createElement('script');
    script.src = `https://s1.hdslb.com/bfs/static/player/main/html5/wplayer.js?v=6`;
    document.body.appendChild(script);
    script.onload = () => {
      this.getTabsDataList();
    };
    await action.getUserInfo();
  }

  // tabs切换
  handleTabChange(item: any, index: number) {
    this.isMask = true;
    this.chooseIdx = index;
    this.bvid = item?.properties.bvid;
    const newImgGif = item?.properties?.img_gif_h5?.url;
    this.actId = item.properties.vote_id;
    this.groupId = item.properties.group_id;
    this.imgUrl = newImgGif;

    this.initPlayer(this.bvid)

    this.getVoteDataList(this.actId, this.groupId);
  }

  // 实例化播放器
  initPlayer(bvid: string) {
    // 销毁player
    if (this.player) {
      this.player.dispose();
    }

    const iframe = document.getElementById('iframe');
    this.player = new (window as any).WPlayer({
      wrap: iframe,
      autoplay: false,
      bvid: bvid,
      hideCoverInfo: true
    });
    this.player.on((window as any).WPlayer.events.VIDEO_PLAY, (e: any) => {
      this.isMask = false;
    });
    this.player.on((window as any).WPlayer.events.VIDEO_PAUSE, (e: any) => {
      this.isMask = true;
    });
  }

  // 投票
  handleVote(voteName: string) {
    if (!this.getUserInfo) {
      login();
      return;
    }
    VoteDo(this.actId, this.groupId, this.datasourceIitemObject[voteName]).then(
        (res: any) => {
          this.isVote = true;
          this.initPlayer(this.bvid)
          this.getVoteDataList(this.actId, this.groupId);
        }
    );
  }

  // 获取投票数据源
  getVoteDataList(actId: number, groupId: number) {
    getVoteData(actId, groupId).then((res: any) => {
      this.voteList = res.list;
      this.userCanVoteCount1 = res.list && res.list[0]?.user_can_vote_count;
      this.userCanVoteCount2 = res.list && res.list[1]?.user_can_vote_count;
      const vote1 = res.list && res.list[0]?.vote;
      const vote2 = res.list && res.list[1]?.vote;
      this.datasourceIitemObject = {
        left: res.list && res.list[0]?.datasource_item_id,
        right: res.list && res.list[1]?.datasource_item_id,
      };
      this.isVote = this.userCanVoteCount1 === 0 || this.userCanVoteCount2 === 0;
      if (vote1 === 0 && vote2 === 0) {
        this.leftRatio = 50;
        this.rightRatio = 50;
      } else {
        this.leftRatio = parseInt((Math.round(vote1 / (vote1 + vote2)*100)).toString())
        this.rightRatio = 100 - this.leftRatio;
      }
      this.sonQuery = this.getSonComponentQuery(
          this.leftRatio,
          this.rightRatio
      );
    });
  }

  // 获取投票需要的参数
  getSonComponentQuery(leftRatio: number, rightRatio: number) {
    return getScoreProcessWidth(leftRatio, rightRatio, 482, 120, false);
  }

  // 获取运营数据源（tabs标签）
  getTabsDataList() {
    getTabsData().then((res: any) => {
      this.tabsDataList = res.list;
      this.bvid = res.list && res.list[0]?.properties.bvid;
      const imgGif = res.list && res.list[0]?.properties?.img_gif_h5?.url;
      this.imgUrl = imgGif;
      this.actId = res.list && res.list[0]?.properties.vote_id;
      this.groupId = res.list && res.list[0]?.properties.group_id;
      // this.player.reload({
      //   bvid: bvid,
      //   autoplay: false,
      // });
      this.initPlayer(this.bvid)

      this.getVoteDataList(this.actId, this.groupId);
    });
  }
}
